import * as React from 'react'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface SimpleDialogProps {
    isOpen: boolean
    closeModal: () => void
    dialogTitle: string
    children: React.ReactNode
    maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full'
    zIndex?: string
}

const maxWidthMap = {
    sm: 'sm:max-w-[425px]',
    md: 'sm:max-w-[600px]',
    lg: 'sm:max-w-[800px]',
    xl: 'sm:max-w-[1000px]',
    '2xl': 'sm:max-w-[1200px]',
    full: 'sm:max-w-full',
}

export default function SimpleDialog({
    isOpen,
    closeModal,
    dialogTitle,
    children,
    maxWidth = 'md',
    zIndex,
}: SimpleDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && closeModal()}>
            <DialogContent className={cn(maxWidthMap[maxWidth], zIndex)}>
                <DialogHeader>
                    <DialogTitle>{dialogTitle}</DialogTitle>
                </DialogHeader>
                <div className="py-4">{children}</div>
            </DialogContent>
        </Dialog>
    )
}
